import { render, staticRenderFns } from "./aviso-de-operaciones.vue?vue&type=template&id=2c6fa1f7&lang=html&"
import script from "./aviso-de-operaciones.vue?vue&type=script&lang=js&"
export * from "./aviso-de-operaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports